import { configureStore } from '@reduxjs/toolkit';
import { playerReducer } from './slices/playerSlice';
import { resourceReducer } from './slices/resourceSlice';
import { worldReducer } from './slices/worldSlice';

export const store = configureStore({
  reducer: {
    player: playerReducer,
    resources: resourceReducer,
    world: worldReducer,
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 